import MyLayout from "@/MyLayout/MyLayout";
import { MyAppsGrid } from "@/MyLayout/MyAppGrid";
import { useNavigate } from "react-router-dom";
import {
  Bell,
  Newspaper,
  TrendingUp,
  ShieldCheck,
} from "lucide-react";
import { useMyDialog } from "@/context/MyDialogProvider";
import CorsChecker from "./CorsChecker";

const ScraperPage = () => {
  const navigate = useNavigate();
  const { open } = useMyDialog();

  const apps = [
    {
      key: "gazette",
      title: "Gazette Announcements",
      description: "Browse government announcements",
      icon: <Bell size={24} />,
      href: "/mviulaan",
    },
    {
      key: "news",
      title: "MV News",
      description: "Latest Maldives news",
      icon: <Newspaper size={24} />,
      href: "/mvnews",
    },
    {
      key: "stocks",
      title: "MV Stocks",
      description: "Stock market information",
      icon: <TrendingUp size={24} />,
      href: "/mvstocks",
    },
    {
      key: "cors",
      title: "CORS Checker",
      description: "Test website CORS access",
      icon: <ShieldCheck size={24} />,
      action: () =>
        open({
          content: <CorsChecker />,
        }),
    },
  ];


  return (
    <MyLayout
      title="News & Information"

      actions={[
        {
          id: "gazette",
          icon: <Bell size={18} />,
          label: "Gazette",
          onClick: () =>
            navigate("/mviulaan"),
        },
        {
          id: "news",
          icon: <Newspaper size={18} />,
          label: "News",
          onClick: () =>
            navigate("/mvnews"),
        },
        {
          id: "stocks",
          icon: <TrendingUp size={18} />,
          label: "Stocks",
          onClick: () =>
            navigate("/mvstocks"),
        },
      ]}

      main={
        <MyAppsGrid
          apps={apps}
          onOpen={(app) => {
            if ("action" in app && app.action) {
              app.action();
              return;
            }

            if (app.href) {
              navigate(app.href);
            }
          }}
        />
      }
    />
  );
};

export default ScraperPage;